<div
  class="meal-summary-report flex flex-col min-h-[calc(100vh-100px)] w-full bg-[#F7FAFC] font-['Archivo',sans-serif] px-[24px] md:px-[32px] lg:px-[40px] pt-[24px] pb-[32px]">
  <div *ngIf="isInitialLoading" class="flex flex-col items-center justify-center w-full py-[80px] gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215] text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isInitialLoading">
    <div
      class="meal-summary-report__panel w-full bg-white rounded-[12px] border border-[#EAECF0] shadow-[0_1px_3px_rgba(16,24,40,0.08),0_1px_2px_rgba(16,24,40,0.06)] p-[24px] flex flex-col gap-[20px]">
      <div class="flex flex-row flex-wrap items-center justify-between gap-[16px]">
        <div class="flex flex-row flex-wrap items-center gap-[16px]">
          <button
            type="button"
            class="inline-flex items-center justify-center gap-[8px] box-border h-[44px] px-[16px] rounded-[16px] border border-[#D0D5DD] bg-white text-[#101828] text-[16px] font-semibold leading-[20px] cursor-pointer hover:bg-[#F9FAFB]"
            (click)="goBack()"
            aria-label="Back">
            <svg
              class="w-5 h-5 shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M20 12H4M4 12L10 18M4 12L10 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Back</span>
          </button>
          <h1 class="text-[#111215] font-bold text-[24px] leading-[32px] tracking-[-0.01em] m-0">
            Meal Summary Report
          </h1>
        </div>

        <div class="flex flex-row flex-wrap items-center gap-[10px] justify-end">
          <!-- Same as Activity Report: custom date range labeled "Aug 08 2026", default today -->
          <label class="sr-only" for="meal-summary-report-from">From date</label>
          <div
            class="meal-summary-report__date-wrap"
            role="button"
            tabindex="0"
            (click)="openDatePicker($event)"
            (keydown.enter)="openDatePicker($event)"
            (keydown.space)="$event.preventDefault(); openDatePicker($event)">
            <span class="meal-summary-report__date-label" aria-hidden="true">
              {{ formatDatePickerLabel(customFromDate) }}
            </span>
            <input
              id="meal-summary-report-from"
              type="date"
              class="meal-summary-report__date-input"
              [(ngModel)]="customFromDate"
              (click)="openDatePicker($event); $event.stopPropagation()"
              (ngModelChange)="onFiltersChanged()" />
          </div>

          <label class="sr-only" for="meal-summary-report-to">To date</label>
          <div
            class="meal-summary-report__date-wrap"
            role="button"
            tabindex="0"
            (click)="openDatePicker($event)"
            (keydown.enter)="openDatePicker($event)"
            (keydown.space)="$event.preventDefault(); openDatePicker($event)">
            <span class="meal-summary-report__date-label" aria-hidden="true">
              {{ formatDatePickerLabel(customToDate) }}
            </span>
            <input
              id="meal-summary-report-to"
              type="date"
              class="meal-summary-report__date-input"
              [(ngModel)]="customToDate"
              (click)="openDatePicker($event); $event.stopPropagation()"
              (ngModelChange)="onFiltersChanged()" />
          </div>

          <label class="sr-only" for="meal-summary-report-center">Center</label>
          <select
            id="meal-summary-report-center"
            class="meal-summary-report__select meal-summary-report__toolbar-control h-[40px] min-w-[160px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] pr-[36px] outline-none focus:border-[#F26F24] cursor-pointer"
            [(ngModel)]="filterCenterName"
            (ngModelChange)="onFiltersChanged()">
            <option value="">All Centers</option>
            <option *ngFor="let center of centers" [value]="center.locationName">
              {{ center.locationName }}
            </option>
          </select>

          <button
            type="button"
            class="meal-summary-report__toolbar-control inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#D0D5DD] bg-white cursor-pointer hover:bg-[#F9FAFB] disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="onDownload()"
            [disabled]="!rows.length">
            <img src="assets/icons/download.svg" alt="" class="w-[16px] h-[16px]" />
            Download
          </button>
        </div>
      </div>

      <div *ngIf="errorMessage" class="text-red-600 text-[14px]">
        {{ errorMessage }}
      </div>

      <div *ngIf="isRefreshing" class="text-[#667085] text-[13px]">Updating…</div>

      <div class="meal-summary-report__table w-full overflow-x-auto">
        <table *ngIf="!errorMessage" class="w-full border-collapse min-w-full">
          <thead>
            <tr>
              <th scope="col" class="text-left">User Name</th>
              <th scope="col" class="text-left">Meal</th>
              <th scope="col" class="text-left">Type</th>
              <th scope="col" class="text-left">Center</th>
              <th scope="col" class="text-left">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!rows.length">
              <td class="text-center text-[#667085] text-[18px] font-medium py-[40px]" colspan="5">
                No meal records found for this period.
              </td>
            </tr>
            <tr *ngFor="let row of rows; trackBy: trackByRow">
              <td class="text-left whitespace-nowrap">{{ row.userName }}</td>
              <td class="text-left whitespace-nowrap">{{ row.meal }}</td>
              <td class="text-left whitespace-nowrap">{{ row.type }}</td>
              <td class="text-left whitespace-nowrap">{{ row.center }}</td>
              <td class="text-left whitespace-nowrap">{{ formatDate(row.mealDate) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>
